import axios from 'axios';
import { API_CONFIG } from '../config/api.config';
import { useAuthStore } from '../store/authStore';
import { ROUTES } from '../config/routes.config';

const axiosInstance = axios.create({
  baseURL: `${API_CONFIG.BASE_URL}/api/rrms`,
  timeout: API_CONFIG.TIMEOUT,
  headers: { 'Content-Type': 'application/json' },
});

axiosInstance.interceptors.request.use((config) => {
  const authState = useAuthStore.getState();
  const token = localStorage.getItem('rrms_token') || authState.token;
  const role = localStorage.getItem('rrms_role') || authState.role;
  const divisionId =
    localStorage.getItem('rrms_division_id') ||
    (authState.user?.division_id != null
      ? String(authState.user.division_id)
      : null);
  const departmentId =
    localStorage.getItem('rrms_department_id') ||
    (authState.user?.department_id != null
      ? String(authState.user.department_id)
      : null);
  const designationId =
    localStorage.getItem('rrms_designation_id') ||
    (authState.user?.designation_id != null
      ? String(authState.user.designation_id)
      : null);
  const userJson = localStorage.getItem('rrms_user');
  let displayName: string | null = null;

  if (userJson) {
    try {
      const user = JSON.parse(userJson) as {
        name?: string;
        kgid?: string;
        role_title?: string;
        designation?: string;
        designation_name?: string;
        desig_name?: string;
      };

      // Prefer showing the officer's actual name in the UI.
      if (user.name && user.name.trim().length > 0) {
        displayName = user.name.trim();
      } else {
        const designation =
          user.designation || user.designation_name || user.desig_name;
        const parts: string[] = [];
        if (designation) parts.push(designation);
        if (user.kgid) parts.push(`KGID ${user.kgid}`);
        displayName = parts.length ? parts.join(' - ') : null;
      }
    } catch {
      displayName = null;
    }
  }

  if (displayName) {
    (config.headers as any)['x-user-name'] = displayName;
  }

  if (token) (config.headers as any).token = token;
  if (role) (config.headers as any)['x-role-title'] = role;
  if (divisionId) (config.headers as any)['x-division-id'] = divisionId;
  if (departmentId) (config.headers as any)['x-department-id'] = departmentId;
  if (designationId)
    (config.headers as any)['x-designation-id'] = designationId;

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Keep Zustand + localStorage in sync on auth expiry/failure.
      useAuthStore.getState().logout();
      if (window.location.pathname !== ROUTES.LOGIN) {
        window.location.href = ROUTES.LOGIN;
      }
    }
    return Promise.reject(error);
  }
);

export const authAxios = axios.create({
  baseURL: `${API_CONFIG.BASE_URL}/api`,  // → http://13.201.229.74/rrms/api
  timeout: API_CONFIG.TIMEOUT,
  headers: { 'Content-Type': 'application/json' },
});

// export const authAxios = axios.create({
//   baseURL: API_CONFIG.BASE_URL.replace(/\/rrms\/?$/, ''),
//   timeout: API_CONFIG.TIMEOUT,
//   headers: { 'Content-Type': 'application/json' },
// });

const isProd = process.env.NODE_ENV === 'production';

// export const authAxios = axios.create({
//   baseURL: isProd
//     // OLD prod behavior (what you currently have commented out)
//     ? API_CONFIG.BASE_URL.replace(/\/rrms\/?$/, '')
//     // NEW dev behavior
//     : `${API_CONFIG.BASE_URL.replace(/\/rrms\/?$/, '')}/api`,
//   timeout: API_CONFIG.TIMEOUT,
//   headers: { 'Content-Type': 'application/json' },
// });
export default axiosInstance;

